import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import AppStrings from '../../config/appstring';
import { handleExport } from '../Print/ExportToExcel';

const SelectDataReport = ({ onClose, REPORTLISTNAME }) => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState(null);

  useEffect(() => {
    if (REPORTLISTNAME.id !== "0") {
      fetchData();
    } else {
      fetchData1();
    }
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(AppStrings.ReportQryListView + `?ID=${REPORTLISTNAME.id}`);
      const result = response.data.data;
      if (Array.isArray(result)) {
        setReport(result[0]);
        setError('');
      } else {
        setError('Unexpected response format');
      }
    } catch (err) {
      setError('Failed to fetch data');
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchData1 = async () => {
    const payload = { Datas: REPORTLISTNAME.qry };

    try {
      const res = await fetch(AppStrings.QryList, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
      const result1 = result.data;

      if (Array.isArray(result1)) {
        setReport(result1[0]);
        setError('');
      } else {
        setError('Unexpected response format');
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const exportExcel = () => {
    handleExport(tableRef.current, 'excel', 'StudentFeesReport');
  };

  const exportPDF = () => {
    handleExport(tableRef.current, 'pdf', 'StudentFeesReport');
  };

   const DeleteReport = async () => {
     const payload = { ID: REPORTLISTNAME.id };

    try {
      const res = await fetch(AppStrings.ReportQryListView, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const result = await res.json();
        if (result.success) {
      alert("Report deleted successfully.");
      onClose(); // 🔹 Close the form after successful delete
    } else {
      alert("Failed to delete report.");
    }
  } catch (err) {
    console.error("Error:", err);
    alert("Failed to delete data.");
  } finally {
    setLoading(false);
  }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;
  if (!report) return <p>No report data found.</p>;

  return (
    <div>
      <button style={styles.ExportBtn} onClick={exportExcel}>Export to Excel</button>
      <button style={styles.ExportBtn} onClick={exportPDF}>Export to PDF</button>
      <button style={styles.ExportBtn} onClick={DeleteReport}>Delete</button>

      <div style={styles.tableContainer}>
        <table ref={tableRef} style={styles.table}>
          {/* ✅ Add <colgroup> to enforce column widths */}
          <colgroup>
            {report.headers.flatMap(group =>
              group.columns.map((col, colIdx) => (
                <col key={col.key} style={{ width: col.width || '150px' }} />
              ))
            )}
          </colgroup>

          <thead>
            <tr>
              <th
                colSpan={report.headers.reduce((sum, g) => sum + g.columns.length, 0)}
                style={styles.tableHeaderMain}
              >
                {report.title}
              </th>
            </tr>
            <tr>
              {report.headers.map((group, i) => (
                <th key={i} colSpan={group.columns.length} style={styles.tableHeader}>
                  {group.group}
                </th>
              ))}
            </tr>
            <tr>
              {report.headers.flatMap(group =>
                group.columns.map((col, i) => (
                  <th key={col.key} style={styles.tableHeader}>{col.label}</th>
                ))
              )}
            </tr>
          </thead>
          <tbody>
            {report.data.map((row, rowIdx) => (
              <tr key={rowIdx} style={rowIdx % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd}>
                {report.headers.flatMap(group =>
                  group.columns.map((col, colIdx) => (
                    <td key={col.key} style={styles.tableCell}>
                      {colIdx === 0 && (row[col.key] === null || row[col.key] === '') ? 'Grand Total' : row[col.key]}
                    </td>
                  ))
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SelectDataReport;

const styles = {
  ExportBtn: {
    fontSize: '12px',
    marginRight: '10px',
    marginBottom: '10px',
  },
  tableContainer: {
    maxHeight: '400px',
    overflowY: 'auto',
    border: '1px solid #ddd',
    borderRadius: '8px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
    tableLayout: 'fixed', // required to honor colgroup widths
  },
  tableHeaderMain: {
    backgroundColor: '#f8f9fa',
    fontWeight: 'bold',
    fontSize: '16px',
    padding: '12px',
    textAlign: 'center',
    color: '#343a40',
    borderBottom: '2px solid #dee2e6',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
  tableHeader: {
    backgroundColor: '#e9ecef',
    padding: '10px',
    border: '1px solid #dee2e6',
    fontWeight: '600',
    position: 'sticky',
    top: 38,
    zIndex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableRowOdd: {
    backgroundColor: '#f6f6f6',
  },
  tableCell: {
    padding: '10px',
    border: '1px solid #dee2e6',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  saveButton: {
    marginTop: '20px',
    padding: '8px 16px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  }
};
